import { Box, Button } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import { useNavigate } from "react-router-dom";
import FacultyForm from "../../faculty/components/FacultyForm";
import StaffAddForm from "../components/StaffAddForm";
import { toolbarButtonSx } from "../../../components/common/toolbarStyles";
import { StaffTypeToggle, useStaffKind } from "./StaffTypeToggle";

/** Staff → Add (from the Directory's Add button): tabs on the left, Directory on the right. */
export default function StaffAddPage() {
  const navigate = useNavigate();
  const [kind, setKind, canManageFaculty] = useStaffKind();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2, mr: 2 }}>
      <Box display="flex" alignItems="center" gap={2} sx={{ borderBottom: 1, borderColor: "divider", pb: 1 }}>
        {canManageFaculty && <StaffTypeToggle kind={kind} onChange={setKind} />}
        <Box flexGrow={1} />
        <Button variant="outlined" size="small" sx={toolbarButtonSx} startIcon={<ListIcon />} onClick={() => navigate(`/app/staff?type=${kind}`)}>
          Directory
        </Button>
      </Box>
      {kind === "faculty" ? <FacultyForm /> : <StaffAddForm />}
    </Box>
  );
}
